import styled from 'styled-components';
import Background from 'assets/img/main/ProgBGImage.jpg';

export const StyledContainer = styled('div')`
  overflow-y: hidden;
  min-height: 100vh;
  background-image: ${() => `url(${Background})`};
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: auto;
  margin-right: auto;
`;

export const FormContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 315px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    margin: 60px auto;
  }
`;
